var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.slotProps.item.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }